export const CATEGORIES_ARE_LOADING = 'IS_LOADING';
export const CATEGORIES_ARE_LOADED = 'IS_LOADED';
export const CATEGORIES_ERROR = 'ERROR';

export const PRODUCTS_ARE_LOADING = 'IS_LOADING';
export const PRODUCTS_ARE_LOADED = 'IS_LOADED';
export const PRODUCTS_ERROR = 'ERROR';
export const CATEGORY_SELECTED = 'CATEGORY_SELECTED';

export const FILTER_PRODUCTS = 'FILTER_PRODUCTS';
export const CLEAR_SELECTION = 'CLEAR_SELECTION';

export const PRODUCT_IS_LOADING = 'PRODUCT_IS_LOADING';
export const PRODUCT_IS_LOADED = 'PRODUCT_IS_LOADED';
export const PRODUCT_ERROR = 'PRODUCT_ERROR';

export const LOADING_FAVOURITES = 'LOADING_FAVOURITES';
export const FAVOURITES_LOADED = 'FAVOURITES_LOADED';
export const ADD_FAVOURITE = 'ADD_FAVOURITE';
export const DELETE_FAVOURITE = 'DELETE_FAVOURITE';
export const FAVOURITES_ERROR = 'FAVOURITES_ERROR';
